import React from "react";
import NoMatch from "./NoMatch";

export interface RouteInfo {
  path: string;
  component: any;
  routes?: RouteInfo[];
  lazy?: boolean;
  protected?: boolean;
}

const ReactLazyPreload = (importStatement: any) => {
  const Component: any = React.lazy(importStatement);
  Component.preload = importStatement;
  return Component;
};

const Dashboard = ReactLazyPreload(() => import("./pages/dashboard/Dashboard"));
Dashboard.preload();

const Login = ReactLazyPreload(() => import("./pages/login/Login"));
Login.preload();

const ChangePassword = ReactLazyPreload(
  () => import("./pages/change-password/ChangePassword")
);
ChangePassword.preload();

const Profile = ReactLazyPreload(() => import("./pages/profile/Profile"));
Profile.preload();

const Tenants = ReactLazyPreload(() => import("./pages/tenants/Tenants"));
Tenants.preload();

const RolesInternal = ReactLazyPreload(() => import("./pages/roles-internal/RolesInternal"));
RolesInternal.preload();

const RolesExternal = ReactLazyPreload(() => import("./pages/roles-external/RolesExternal"));
RolesExternal.preload();

const SystemUser = ReactLazyPreload(() => import("./pages/system-user/SystemUser"));
SystemUser.preload();

const Outlets = ReactLazyPreload(() => import("./pages/outlets/Outlets"));
Outlets.preload();

const TenantUsers = ReactLazyPreload(() => import("./pages/tenant-users/TenantUsers"));
TenantUsers.preload();

const Customers = ReactLazyPreload(() => import("./pages/customers/Customers"));
Customers.preload();

const Credits = ReactLazyPreload(() => import("./pages/wallets/Wallets"));
Credits.preload();

const TenantReferrals = ReactLazyPreload(() => import("./pages/tenant-referrals/TenantReferrals"));
TenantReferrals.preload();

const CreditActivities = ReactLazyPreload(() => import("./pages/reports/credits-activity/CreditsActivity"));
CreditActivities.preload();

const CustomerCards = ReactLazyPreload(() => import("./pages/stamp-card/customers/Customers"));
CustomerCards.preload();

const CardSettings = ReactLazyPreload(() => import("./pages/stamp-card/settings/CardSettings"));
CardSettings.preload();

export const routes: RouteInfo[] = [
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/dashboard",
    component: Dashboard,
    protected: true,
  },
  {
    path: "/profile/account",
    component: Profile,
    protected: true,
  },
  {
    path: "/profile/change-password",
    component: ChangePassword,
    protected: true,
  },
  {
    path: "/role-permission",
    component: RolesInternal,
    protected: true,
  },
  {
    path: "/users",
    component: SystemUser,
    protected: true,
  },
  {
    path: "/customers",
    component: Customers,
    protected: true
  },
  {
    path: "/reports",
    component: CreditActivities,
    protected: true
  },
  {
    path: "/tenant-management/role-permission",
    component: RolesExternal,
    protected: true,
  },
  {
    path: "/tenant-management/tenants",
    component: Tenants,
    protected: true,
  },
  {
    path: "/tenant-management/outlets",
    component: Outlets,
    protected: true,
  },
  {
    path: "/tenant-management/users",
    component: TenantUsers,
    protected: true,
  },
  {
    path: "/tenant-management/credit",
    component: Credits,
    protected: true,
  },{
    path: "/tenant-management/referral",
    component: TenantReferrals,
    protected: true
  },
  // {
  //   path: "/stamp-card/customers",
  //   component: CustomerCards,
  //   protected: true
  // },
  {
    path: "/tenant-management/stamp-card",
    component: CardSettings,
    protected: true
  },{
    path: "/",
    component: Dashboard,
    protected: true,
  },
  {
    path: "*",
    component: NoMatch,
  },
];
